import { getTestBed } from "@angular/core/testing";
import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { HelpService } from "../../help-service";
import { Router } from "@angular/router";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/internal/operators";
import { NgSelectModule } from '@ng-select/ng-select';
import { getFormApi } from "src/app/dataObject/GetFormApi";

@Component({
  selector: "app-registerTraining",
  templateUrl: "./registerTraining.component.html",
  styleUrls: ["./registerTraining.component.css"],
})
export class RegisterTrainingComponent implements OnInit {
  existing: any = [];
  emailSalesman: any = [];
  outletCity: any = [];
  outletCityId: any = [];
  sh: any;
  buttonSubmit: boolean;
  buttonLoading: boolean;
  isSubmitted = false;
  @ViewChild("msg") msgElement: ElementRef;


  constructor(
    public helpService: HelpService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private http: HttpClient
  ) {}

  registerCustomerForm = this.fb.group({
    picName: ['', Validators.required],
    emailSalesman: ['', Validators.required],
    picEmail: ['', [Validators.required, Validators.email]],
    picPhoneNumber: [
      '',
      [
        Validators.required,
        Validators.pattern("^((\\+62-?)|0)?[- +()0-9]+"),
        Validators.minLength(10),
        Validators.maxLength(15),
      ]
    ],
    outletName: ['', Validators.required],
    outletCity: ['', Validators.required],
 
  });



  private handleError(error: HttpErrorResponse) {
    let errorMessage = "Something bad happened; please try again later.";
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }


  getCity() {
    this.helpService.getCity().subscribe((data: any) => {
      this.outletCity = data.dataObject.map((data) => data);
    });
  }

  getSale(outletCityId): Observable<any[]> {
    const headers = { 'dc': ""+ outletCityId + "", 'email': ''} 
    return this.http
      .get<any[]>('https://open.sukandaonelink.com/docs/getSales',{'headers':headers})
      .pipe(catchError(this.handleError));
  }

  getSales(outletCityId) {
    this.getSale(outletCityId).subscribe((data: any) => {
      this.emailSalesman = data.dataObject.map((data) => data)
    });
  }

  filterSales(str: string) {
    if (typeof str === 'string') {
        this.emailSalesman = this.emailSalesman.filter(a => a.toLowerCase()
                                             .startsWith(str.toLowerCase())); 
    }
}

  getFormApi: getFormApi;
  ngOnInit(): void {
    this.getCity();
    this.getSales(this.outletCityId);

    this.buttonSubmit = true;
    this.buttonLoading = false;
  }

  get f() {
    return this.registerCustomerForm.controls;
  }

  onSubmit(event) {
    
    this.isSubmitted = true;
    console.log(this.registerCustomerForm.value);
    if (this.registerCustomerForm.valid) {
      this.buttonSubmit = false;
      this.buttonLoading = true;

      this.helpService
        .postSaveCustomerReq(this.registerCustomerForm.value)
        .subscribe(
          (data) => {
            this.getFormApi = data;
            const statusresult = this.getFormApi.status;
            if (this.getFormApi.status === 1) {
              this.toastr.success(this.getFormApi.message);
              console.log(this.getFormApi.message);
              alert(this.getFormApi.message);
              this.reloadData();
            } else if(this.getFormApi.status === 3){
              this.toastr.success(this.getFormApi.message);
              this.reloadData()
            } else {
              this.toastr.error(this.getFormApi.message);
              alert(this.getFormApi.message);
              console.log(this.getFormApi.message);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      this.validate(this.registerCustomerForm);
      if (
        this.registerCustomerForm.value.picName == '' &&
        this.registerCustomerForm.value.picEmail != '' &&
        this.registerCustomerForm.value.picPhoneNumber != '' &&
        this.registerCustomerForm.value.outletName != ''
      ) 
      {
        setTimeout(() => {
          // this will make the execution after the above boolean has changed
          this.msgElement.nativeElement.focus();
        }, 0);
      } else {
        window.scroll(0, 0);
        alert('Lengkapi Form register Training Customer!');
      }
    }
  }

  validate(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      //{2}
      const control = formGroup.get(field); //{3}
      if (control instanceof FormControl) {
        //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        //{5}
        this.validate(control); //{6}
      }
    });
  }

  reloadData() {
    window.location.reload();
  }

  onChangeCity(event) {
    let branch = this.registerCustomerForm.controls['outletCity'].value;
    const outletCityId= branch
    if (outletCityId) {
      this.getSale(outletCityId)
      this.getSales(outletCityId)
      this.outletCityId = outletCityId
    } else {
      this.emailSalesman = null;
    }
  }

}
